document.addEventListener('DOMContentLoaded', function () {

  // ── NAV SCROLL ────────────────────────────────
  const nav = document.querySelector('.bd-nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 48);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── HERO ANIMATIONS ───────────────────────────
  requestAnimationFrame(() => {
    setTimeout(() => {
      document.querySelectorAll('.hero-anim').forEach(el => el.classList.add('show'));
    }, 80);
  });

  // ── SCROLL REVEAL ─────────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  // ── SMOOTH SCROLL ────────────────────────────
  document.querySelectorAll('[data-scroll]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById(el.dataset.scroll);
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // ── VIDEO PLAYER ─────────────────────────────
  const wrap = document.getElementById('bd-video-wrap');
  const video = document.getElementById('bd-video');
  const playBtn = document.getElementById('bd-play-btn');
  if (wrap && video) {
    wrap.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        wrap.classList.add('playing');
        if (playBtn) playBtn.style.display = 'none';
      } else {
        video.pause();
        wrap.classList.remove('playing');
        if (playBtn) playBtn.style.display = 'flex';
      }
    });
  }

  // ── PRODUCT IMG HOVER SWAP ───────────────────
  document.querySelectorAll('[data-img-hover]').forEach(card => {
    const img = card.querySelector('.bd-product-img-wrap img');
    if (!img) return;
    const main = img.getAttribute('src');
    const hover = card.dataset.imgHover;
    card.addEventListener('mouseenter', () => { if (hover) img.src = hover; });
    card.addEventListener('mouseleave', () => { img.src = main; });
  });

});
